import "./LiquidBackdrop.css";

// Fixed, full-viewport animated gradient mesh that sits behind the entire
// homepage so the glass hero panel has something colorful to blur against.
export default function LiquidBackdrop() {
  return (
    <div className="liquid-backdrop" aria-hidden="true">
      <div className="liquid-blob liquid-blob--saffron" />
      <div className="liquid-blob liquid-blob--green" />
      <div className="liquid-blob liquid-blob--navy" />
      <div className="liquid-blob liquid-blob--gold" />
      <div className="liquid-grain" />
    </div>
  );
}
